import Vue from "vue";
import Router from "vue-router";
import auth from "@/auth/authService";
import store from "@/store";
import User from "@/models/User.js";
import {firebaseInstance as firebase} from "@/main";
import "firebase/auth";

Vue.use(Router);

const router = new Router({
	mode: "history",
	base: process.env.BASE_URL,
	scrollBehavior() {
		return {x: 0, y: 0};
	},
	routes: [
		{
			// =============================================================================
			// MAIN LAYOUT ROUTES
			// =============================================================================
			path: "",
			component: () => import("@/layouts/main/Main.vue"),
			children: [
				// =============================================================================
				// Theme Routes
				// =============================================================================
				{
					path: "/",
					redirect: "/pages/login",
				},
				{
					path: "/dashboard/maps",
					name: "dashboard-maps",
					component: () => import("@/views/Maps.vue"),
					meta: {
						rule: "editor",
						authRequired: true,
						permission_id: 20,
						permission_name: "MAP",
						module_name: "MAP",
					},
				},

				{
					path: "/dashboard/company",
					name: "company",
					component: () => import("@/components/Company/Company.vue"),
					meta: {
						authRequired: true,
						i18n: "Company",
						rule: "admin",
						permission_id: 15,
						permission_name: "COMPANY",
						module_name: "COMPANY",
					},
				},
				{
					path: "/dashboard/company/list",
					name: "companyListView",
					component: () => import("@/components/Company/CompanyListView.vue"),
					meta: {
						authRequired: true,
						rule: "admin",
						permission_id: 15,
						permission_name: "COMPANY",
						module_name: "COMPANY",
					},
				},
				{
					path: "/dashboard/company-config-crud/:company_id?",
					name: "company-config-crud",
					component: () => import("@/components/Company-config-crud/CompanyConfigCrud.vue"),
					meta: {
						authRequired: true,
						i18n: "CompanyConfigCrud",
						rule: "admin",
						permission_id: 19,
						permission_name: "COMPANY_CONFIG",
						module_name: "COMPANY_CONFIG",
					},
				},
				{
					path: "/dashboard/type-config-crud",
					name: "TypeConfigCrud",
					component: () => import("@/components/type-config-crud/TypeConfigCrud.vue"),
					meta: {
						authRequired: true,
						i18n: "TypeConfig",
						rule: "admin",
						permission_id: 22,
						permission_name: "TYPE_CONFIG",
						module_name: "TYPE_CONFIG",
					},
				},
				{
					path: "/dashboard/roles",
					name: "Roles",
					component: () => import("@/components/roles/Roles.vue"),
					meta: {
						authRequired: true,
						i18n: "Roles.Roles",
						rule: "editor",
						permission_id: 17,
						permission_name: "ROLE",
						module_name: "ROLE",
					},
				},
				{
					path: "/dashboard/preferences/:id?",
					name: "dashboard-preferences",
					component: () => import("@/components/preferences/Preferences.vue"),
					meta: {
						authRequired: true,
						breadcrumb: [
							{title: "Home", url: "/"},
							{title: "Data List"},
							{
								title: "List",
								active: true,
							},
						],
						pageTitle: "Preferences.Preferences",
						i18n: "Preferences.Preferences",
						rule: "editor",
						permission_id: 17,
						permission_name: "ROLE",
						module_name: "ROLE",
					},
				},
				{
					path: "/dashboard/permissions",
					name: "Permissions",
					component: () => import("@/components/permissions/Permissions.vue"),
					meta: {
						authRequired: true,
						i18n: "Permissions.Permissions",
						rule: "admin",
						permission_id: 18,
						permission_name: "PERMISSION",
						module_name: "PERMISSION",
					},
				},
				{
					path: "/dashboard/status",
					name: "Status",
					component: () => import("@/components/status/Status.vue"),
					meta: {
						authRequired: true,
						i18n: "StatusModule.StatusLink",
						rule: "admin",
						permission_id: 24,
						permission_name: "STATUS",
						module_name: "STATUS",
					},
				},
				{
					path: "/dashboard/setting/:company_id?",
					name: "app-setting",
					component: () => import("@/components/setting/AppSettings.vue"),
					meta: {
						authRequired: true,
						i18n: "Setting.Setting",
						rule: "editor",
						permission_id: 24,
						permission_name: "STATUS",
						module_name: "STATUS",
					},
				},
				{
					path: "/dashboard/status-mobile",
					name: "StatusMobile",
					component: () => import("@/components/statusMobile/StatusMobile.vue"),
					meta: {
						authRequired: true,
						i18n: "StatusMobile.StatusMobile",
						rule: "editor",
						permission_id: 24,
						permission_name: "STATUS",
						module_name: "STATUS",
					},
				},
				{
					path: "/dashboard/session-api/:id?",
					name: "session-api",
					component: () => import("@/components/session-api/SessionApi.vue"),
					meta: {
						authRequired: true,
						i18n: "SessionApi.SessionApi",
						rule: "editor",
						permission_id: 24,
						permission_name: "SESSION_API",
						module_name: "SESSION_API",
					},
				},
				// =============================================================================
				// Application Routes
				// =============================================================================

				{
					path: "/apps/activity",
					name: "app-activity-create",
					component: () => import("@/components/activity/Activity.vue"),
					meta: {
						rule: "editor",
						permission_id: 5,
						permission_name: "ACTIVITY",
						module_name: "ACTIVITY",
					},
				},
				{
					path: "/apps/zonification",
					name: "app-zonification",
					component: () => import("@/components/zonification/Zonification.vue"),
					meta: {
						rule: "editor",
						permission_id: 9,
						permission_name: "ZONIFICATION",
						module_name: "ZONIFICATION",
					},
				},
				{
					path: "/apps/UploadFiles",
					name: "app-upload-files",
					component: () => import("@/components/upload-file/UploadFile.vue"),
					meta: {
						rule: "editor",
						permission_id: 10,
						permission_name: "UPLOAD_FILES",
						module_name: "UPLOAD_FILES",
					},
				},
				{
					path: "/apps/manual-data/:id",
					name: "app-manual-data",
					component: () => import("@/components/upload-file/ManualDataList.vue"),
					meta: {
						rule: "editor",
						permission_id: 2,
						permission_name: "VISIT_POINT",
						module_name: "VISIT_POINT",
					},
				}, //

				{
					path: "/apps/resource/resource-list",
					name: "app-resource-list",
					component: () => import("@/components/resource/user-list/ResourceList.vue"),
					meta: {
						authRequired: true,
						rule: "editor",
						permission_id: 1,
						permission_name: "RESOURCES",
						module_name: "RESOURCES",
					},
				},
				{
					path: "/apps/resource/resource-edit/:userId",
					name: "app-resource-edit",
					component: () => import("@/components/resource/resource-edit/ResourceEdit.vue"),
					meta: {
						authRequired: true,
						rule: "editor",
						permission_id: 1,
						permission_name: "RESOURCES",
						module_name: "RESOURCES",
					},
				},
				{
					path: "/apps/resource/resource-view/:userId",
					name: "app-resource-view",
					component: () => import("@/components/resource/ResourceView.vue"),
					meta: {
						authRequired: true,
						rule: "editor",
						permission_id: 1,
						permission_name: "RESOURCES",
						module_name: "RESOURCES",
					},
				},
				{
					path: "/apps/resource/resource-create",
					name: "app-resource-create",
					component: () => import("@/components/resource/resource-create/ResourceCreate.vue"),
					meta: {
						rule: "editor",
						permission_id: 1,
						permission_name: "RESOURCES",
						module_name: "RESOURCES",
					},
				},
				{
					path: "/apps/resource/definition",
					name: "app-resource-definition",
					component: () => import("@/components/resource/DefinitionResource.vue"),
					meta: {
						rule: "editor",
						permission_id: 3,
						permission_name: "OBJECTS",
						module_name: "OBJECTS",
					},
				},
				// Tipology
				{
					path: "/apps/tipology",
					name: "tipology",
					component: () => import("@/components/tipology/Tipology.vue"),
					meta: {
						rule: "admin",
						permission_id: 16,
						permission_name: "TYPOLOGY",
						module_name: "TYPOLOGY",
					},
				},
				//Category
				{
					path: "/apps/category",
					name: "Category",
					component: () => import("@/components/category/Category.vue"),
					meta: {
						rule: "editor",
						permission_id: 3,
						permission_name: "OBJECTS",
						module_name: "OBJECTS",
					},
				},
				{
					path: "/apps/category/list",
					name: "List",
					component: () => import("@/components/category/CategoryList.vue"),
					meta: {
						rule: "editor",
						permission_id: 3,
						permission_name: "OBJECTS",
						module_name: "OBJECTS",
					},
				},
				{
					path: "/apps/visit-point/create/:id?",
					name: "app-visit-point-create",
					component: () => import("@/components/visit-point/create/VisitPointCreate.vue"),
					meta: {
						rule: "editor",
						permission_id: 2,
						permission_name: "VISIT_POINT",
						module_name: "VISIT_POINT",
					},
				}, //
				{
					path: "/apps/visit-point/visit-point-edit/:id",
					name: "app-visit-point-edit",
					component: () => import("@/components/visit-point/edit/VisitPointEdit.vue"),
					meta: {
						rule: "editor",
						permission_id: 2,
						permission_name: "VISIT_POINT",
						module_name: "VISIT_POINT",
					},
				},
				{
					path: "/apps/visit-point/visit-point-list",
					name: "app-visit-point-list",
					component: () => import("@/components/visit-point/list/VisitPointViewtList.vue"),
					meta: {
						rule: "editor",
						permission_id: 2,
						permission_name: "VISIT_POINT",
						module_name: "VISIT_POINT",
					},
				},
				{
					path: "/apps/visit-point/visit-point-view/:id",
					name: "app-visit-point-view",
					component: () => import("@/components/visit-point/VisitPointView.vue"),
					meta: {
						rule: "editor",
						permission_id: 2,
						permission_name: "VISIT_POINT",
						module_name: "VISIT_POINT",
					},
				},
				{
					path: "/apps/visit-point/visit-point-recurrence/:id",
					name: "app-visit-point-recurrence",
					component: () => import("@/components/visit-point/recurrence/RecurrenceEvents.vue"),
					meta: {
						rule: "editor",
						permission_id: 2,
						permission_name: "VISIT_POINT",
						module_name: "VISIT_POINT",
					},
				},
				// USER CALENDAR
				{
					path: "/apps/calendar/resource-calendar/:id?",
					name: "resource-calendar",
					component: () => import("@/components/calendar/ResourceCalendar.vue"),
					meta: {
						authRequired: true,
						rule: "editor",
						no_scroll: true,
						permission_id: 7,
						permission_name: "CALENDAR",
						module_name: "CALENDAR",
					},
				},
				{
					path: "/apps/calendar/create-event/:resource_id?/:event_id?",
					name: "calendar-create-event",
					component: () => import("@/components/calendar/CreateEvent.vue"),
					meta: {
						authRequired: true,
						rule: "editor",
						no_scroll: true,
						permission_id: 7,
						permission_name: "CALENDAR",
						module_name: "CALENDAR",
					},
				},
				{
					path: "/apps/calendar/update-event/:resource_id?/:event_id?",
					name: "calendar-update-event",
					component: () => import("@/components/calendar/CreateEvent.vue"),
					meta: {
						authRequired: true,
						rule: "editor",
						no_scroll: true,
						permission_id: 7,
						permission_name: "CALENDAR",
						module_name: "CALENDAR",
					},
				},

				{
					path: "/apps/calendar/follower",
					name: "calendar-follower",
					component: () => import("@/components/follower/index.vue"),

					meta: {
						authRequired: true,
						rule: "editor",
						no_scroll: true,
						permission_id: 7,
						permission_name: "CALENDAR",
						module_name: "CALENDAR",
					},
				},

				{
					path: "/apps/calendar/follower/create/:event_id?",
					name: "calendar-follower-create",
					component: () => import("@/components/follower/FollowerForm.vue"),
					meta: {
						authRequired: true,
						rule: "editor",
						no_scroll: true,
						permission_id: 7,
						permission_name: "CALENDAR",
						module_name: "CALENDAR",
					},
				},

				{
					path: "apps/update/:event_id/:follower_id",
					name: "calendar-follower-update",
					component: () => import("@/components/follower/FollowerForm.vue"),
					meta: {
						authRequired: true,
						rule: "editor",
						no_scroll: true,
						permission_id: 7,
						permission_name: "CALENDAR",
						module_name: "CALENDAR",
					},
				},

				{
					path: "apps/calendar/follower/list",
					name: "calendar-follower-list",
					component: () => import("@/components/follower/FollowerList.vue"),
					meta: {
						authRequired: true,
						rule: "editor",
						no_scroll: true,
						permission_id: 7,
						permission_name: "CALENDAR",
						module_name: "CALENDAR",
					},
				},
				{
					path: "/app/group/group-list",
					name: "group-list",
					component: () => import("@/components/group/Group.vue"),
					meta: {
						rule: "editor",
						permission_id: 4,
						permission_name: "GROUPS",
						module_name: "GROUPS",
					},
				},
				{
					path: "/apps/alarm/battery",
					name: "apps-alarm-battery",
					component: () => import("@/components/alarm/battery/BatteryAlarm.vue"),
					meta: {
						rule: "editor",
						permission_id: 8,
						permission_name: "ALARMS",
						module_name: "ALARMS",
					},
				},
				{
					path: "/apps/alarm/gps",
					name: "apps-alarm-gps",
					component: () => import("@/components/alarm/gps/GpsAlarm.vue"),
					meta: {
						rule: "editor",
						permission_id: 8,
						permission_name: "ALARMS",
						module_name: "ALARMS",
					},
				},
				{
					path: "/apps/alarm/radio",
					name: "apps-alarm-radio",
					component: () => import("@/components/alarm/radio/RadioAlarm.vue"),
					meta: {
						rule: "editor",
						permission_id: 8,
						permission_name: "ALARMS",
						module_name: "ALARMS",
					},
				},
				{
					path: "/apps/alarm/schedule",
					name: "apps-alarm-schedule",
					component: () => import("@/components/alarm/schedule/ScheduleAlarm.vue"),
					meta: {
						rule: "editor",
						permission_id: 8,
						permission_name: "ALARMS",
						module_name: "ALARMS",
					},
				},
				{
					path: "/apps/alarm/zone",
					name: "apps-alarm-zone",
					component: () => import("@/components/alarm/zone/ZoneAlarm.vue"),
					meta: {
						rule: "editor",
						permission_id: 8,
						permission_name: "ALARMS",
						module_name: "ALARMS",
					},
				},
				{
					path: "/apps/alarm/speed",
					name: "apps-alarm-speed",
					component: () => import("@/components/alarm/speed/SpeedAlarm.vue"),
					meta: {
						rule: "editor",
						permission_id: 8,
						permission_name: "ALARMS",
						module_name: "ALARMS",
					},
				},
				{
					path: "/apps/reports",
					name: "apps-reports",
					component: () => import("@/components/report/Reports.vue"),
					meta: {
						rule: "editor",
						permission_id: 11,
						permission_name: "REPORTS",
						module_name: "REPORTS",
					},
				},
				{
					path: "/apps/reports/list",
					name: "apps-reports-list",
					component: () => import("@/components/report/ReportList.vue"),
					meta: {
						rule: "editor",
						permission_id: 11,
						permission_name: "REPORTS",
						module_name: "REPORTS",
					},
					children: [
						{
							path: "/apps/reports/list/:id",
							name: "apps-reports-list-id",
							component: () => import("@/components/report/ReportListFiles.vue"),
							meta: {
								rule: "editor",
								permission_id: 11,
								permission_name: "REPORTS",
								module_name: "REPORTS",
							},
						},
					],
				},
				{
					path: "/apps/communication",
					name: "apps-communication",
					component: () => import("@/components/communication/Communication.vue"),
					meta: {
						rule: "editor",
						no_scroll: true,
						permission_id: 13,
						permission_name: "COMMUNICATION",
						module_name: "COMMUNICATION",
					},
				},
				{
					path: "/apps/on-demand",
					name: "apps-on-demand",
					component: () => import("@/components/quick-service/OnDemand.vue"),
					meta: {
						rule: "editor",
						no_scroll: true,
						permission_id: 13,
						permission_name: "ONDEMAND",
						module_name: "ON_DEMAND",
					},
				},
				{
					path: "/apps/on-demand-history",
					name: "apps-on-demand-history",
					component: () => import("@/components/quick-service/OnDemandHistory.vue"),
					meta: {
						rule: "editor",
						permission_id: 13,
						permission_name: "ONDEMAND",
						module_name: "ON_DEMAND",
					},
				},
				{
					path: "/apps/indicator",
					name: "app-indicator-create",
					component: () => import("@/components/indicator/Indicator.vue"),
					meta: {
						rule: "editor",
						permission_id: 12,
						permission_name: "INDICATORS",
						module_name: "INDICATORS",
					},
				},
				{
					path: "/apps/massive-assignment",
					name: "app-massive-assignment",
					component: () => import("@/components/massive-assignment/MassiveAssignment.vue"),
					meta: {
						rule: "editor",
						permission_id: 12,
						permission_name: "MASSIVE_ASSIGNMENT",
						module_name: "MASSIVE_ASSIGNMENT",
					},
				},
				{
					path: "/apps/chat",
					name: "chat",
					component: () => import("@/components/chat/Chat.vue"),
					meta: {
						rule: "editor",
						no_scroll: true,
						permission_id: 12,
						permission_name: "CHAT",
						module_name: "CHAT",
					},
				},
				{
					path: "/apps/serviform",
					name: "app-serviform",
					//component: () => import('@/components/indicator/Indicator.vue'),
					meta: {
						pageTitle: "serviform",
						rule: "editor",
						permission_id: 46,
						permission_name: "SERVIFORMS_R",
						module_name: "SERVIFORMS_R",
					},
				},
				{
					path: "/apps/serviroute",
					name: "app-serviroute",
					meta: {
						pageTitle: "serviform",
						rule: "editor",
						permission_id: 68,
						permission_name: "SERVIROUTES_R",
						module_name: "SERVIROUTES_R",
					},
				},
			],
		},
		// =============================================================================
		// FULL PAGE LAYOUTS
		// =============================================================================
		{
			path: "",
			component: () => import("@/layouts/full-page/FullPage.vue"),
			children: [
				// =============================================================================
				// PAGES
				// =============================================================================
				{
					path: "/callback",
					name: "auth-callback",
					component: () => import("@/views/Callback.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/login/:reload?",
					name: "page-login",
					component: () => import("@/views/pages/login/Login.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/register",
					name: "page-register",
					component: () => import("@/views/pages/register/Register.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/forgot-password",
					name: "page-forgot-password",
					component: () => import("@/views/pages/ForgotPassword.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/reset-password",
					name: "page-reset-password",
					component: () => import("@/views/pages/ResetPassword.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/create-password",
					name: "page-create-password",
					component: () => import("@/views/pages/CreatePasswordInsertCode.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/create-password/:code?",
					name: "page-create-password-code",
					component: () => import("@/views/pages/CreateVisitPointPassword.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/lock-screen",
					name: "page-lock-screen",
					component: () => import("@/views/pages/LockScreen.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/comingsoon",
					name: "page-coming-soon",
					component: () => import("@/views/pages/ComingSoon.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/error-404",
					name: "page-error-404",
					component: () => import("@/views/pages/Error404.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/error-500",
					name: "page-error-500",
					component: () => import("@/views/pages/Error500.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/not-authorized",
					name: "page-not-authorized",
					component: () => import("@/views/pages/NotAuthorized.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/maintenance",
					name: "page-maintenance",
					component: () => import("@/views/pages/Maintenance.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/search/:id?",
					name: "page-search",
					component: () => import("@/views/pages/EventTracking.vue"),
					meta: {
						rule: "editor",
					},
				},
			],
		},
		// Redirect to 404 page, if no match found
		{
			path: "*",
			redirect: "/pages/error-404",
		},
	],
});

const getUser = async () => {
	const user = new User();
	const userSession = await user.getUser();
	return userSession;
};

const getIndexedPreferences = async () => {
	const userInfo = JSON.parse(localStorage.getItem("userInfo"));
	try {
		return await IndexedDB.getKey("preferences", userInfo.uid);
	} catch (error) {
		return error;
	}
};

const findConfigurationByName = async (configName) => {
	const preferences = await getIndexedPreferences();
	if (preferences) {
		const {company_config_list} = preferences;
		if (!company_config_list && !Array.isArray(company_config_list)) return null;
		return company_config_list.find(
			(company_config_list) => company_config_list.type_config_name === configName //"MODULS"
		);
	}
	return null;
};

router.afterEach(() => {
	// Remove initial loading
	const appLoading = document.getElementById("loading-bg");
	if (appLoading) {
		appLoading.style.display = "none";
	}
});

router.beforeEach(async (to, from, next) => {
	const userInfo = JSON.parse(localStorage.getItem("userInfo"));
	const publicPages = [
		"/pages/login",
		"/pages/reset-password",
		"/pages/forgot-password",
		"/pages/not-authorized",
		"/pages/create-password",
		"/pages/search",
	];
	const validatePages = !publicPages.includes(to.fullPath);

	if (userInfo) {
		if (to.fullPath === "/pages/login") {
			next();
		} else if (to.fullPath === "/pages/reset-password") {
			next();
		} else if (to.fullPath === "/pages/forgot-password") {
			next();
		} else if (to.fullPath === "/pages/create-password") {
			next();
		} else if (to.fullPath === "/pages/not-authorized") {
			next();
		} else if (to.fullPath === "/pages/search") {
			next();
		} else {
			// get firebase current user
			const firebaseCurrentUser = firebase.auth().currentUser;
			// If auth required, check login. If login fails redirect to login page
			if (to.meta.authRequired) {
				if (!(auth.isAuthenticated() || firebaseCurrentUser)) {
					//router.push({ path: '/pages/login', query: { to: to.path } })
					//router.push("/pages/login").catch(() => {});
				}
			}
			// Integration with serviforms
			if (to.fullPath === "/apps/serviform") {
				const serviformConfig = store.getters["moduleCompanyConfig/serviformConfig"];
				if (serviformConfig && serviformConfig.config_json) {
					const {token, unlink_form_key, url_conect, company_id} = serviformConfig.config_json;
					let landingUrl = `${url_conect}${token}/${company_id}`;
					window.open(landingUrl, "_blank");
					router.push(from.fullPath).catch(() => {});
				} else {
					store.dispatch("showConfigjsonRequiredNotify", to);
				}
				return;
			}
			// Integration with serviforms
			if (to.fullPath === "/apps/serviroute") {
				const serviformConfig = store.getters["moduleCompanyConfig/servirouteConfig"];
				if (serviformConfig && serviformConfig.config_json) {
					const {url} = serviformConfig.config_json;
					let landingUrl = `${url}/${userInfo.uid}-${userInfo.email}`;
					window.open(landingUrl, "_blank");
					router.push(from.fullPath).catch(() => {});
				} else {
					store.dispatch("showConfigjsonRequiredNotify", to);
				}
				return;
			}
			const modules = await findConfigurationByName("MODULS");
			const module_name = to.meta.module_name || "";
			if (modules && !modules.config_json[module_name.toLocaleLowerCase()]) {
				if (module_name) {
					router.push("/pages/not-authorized").catch(() => {});
				} else {
					router.push(from.fullPath).catch(() => {});
				}
			}
			store.commit("UPDATE_CURRENT_MODULE", to);
			next();
		}
	} else if (validatePages && !userInfo) {
		return next({path: "/pages/login"});
	} else {
		return next();
	}
});

export default router;
